const lbaLeafletMap = angular.module('app.lbaLeafletMap', []);

lbaLeafletMap.controller('lbaLeafletMapCtrl', require('./lbaLeafletMapCtrl'));
lbaLeafletMap.directive('lbaLeafletMap', require('./lbaLeafletMapDir'));

export default lbaLeafletMap;



// WEBPACK FOOTER //
// ./src/components/lbaLeafletMap/index.js